import { render, staticRenderFns } from "./manageAction.vue?vue&type=template&id=bb87d6ba&scoped=true&"
import script from "./manageAction.vue?vue&type=script&lang=js&"
export * from "./manageAction.vue?vue&type=script&lang=js&"
import style0 from "./manageAction.vue?vue&type=style&index=0&id=bb87d6ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb87d6ba",
  null
  
)

export default component.exports